import { render } from "./PaymentReports.vue?vue&type=template&id=39d94af8"
import script from "./PaymentReports.vue?vue&type=script&lang=js"
export * from "./PaymentReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__